import React from 'react';

import { useTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';

import FilterGroupContainer from './FilterGroup';

const FilterComponent = ({ field, filters, isAllSelected, onCloseFilter, onSelectAllFilterValue, sorted, toggleFilter }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="FilterComponent">
      <div className="sidebar-content">
        {filters
          .filter(({ field: f }) => f === field)
          .map((filter) => (
            <FilterGroupContainer key={filter.field} filter={filter} filters={filters} sorted={asArray(sorted)} toggleFilter={toggleFilter} filterActive />
          ))}

        <div className="footer-filter-brand">
          <button data-bem="FilterComponent__all" className="btn btn-violet-link" onClick={() => void onSelectAllFilterValue(field, !isAllSelected)}>
            {isAllSelected ? t('common.buttons.clearAllUpp') : t('common.buttons.selectAllUpp')}
          </button>
          <button data-bem="FilterComponent__done" className="btn btn-violet-link" id="filter-done" onClick={onCloseFilter}>
            {t('common.buttons.doneUpp')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
